import { render, staticRenderFns } from "./PartDocumentPanel.vue?vue&type=template&id=5c988504&scoped=true&"
import script from "./PartDocumentPanel.vue?vue&type=script&lang=js&"
export * from "./PartDocumentPanel.vue?vue&type=script&lang=js&"
import style0 from "./PartDocumentPanel.vue?vue&type=style&index=0&id=5c988504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c988504",
  null
  
)

export default component.exports